// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge--promotions[data-v-84244402] {\n  background: var(--magic-secondary, #9e77ed);\n  --magic-badge-background: $secondary;\n}", ""]);
// Exports
module.exports = exports;
